module.exports = __webpack_public_path__ + "img/build.543dd76.543dd769.png";